import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-error-dialog',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss',
})
export class ErrorDialogComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<ErrorDialogComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; type: string }
  ) {}
}
